import { useOrganization } from '@/contexts/OrganizationContext';

/**
 * The selected org's `show_account_numbers` preference — whether account
 * labels, grids and the P&L show account numbers (Settings → Accounting →
 * Chart of accounts). Read from OrganizationContext (no extra query); true
 * until the org row says otherwise, matching the column default.
 *
 * Pair with `formatAccountLabel(account, show)` from `@releve/shared` for
 * any "number name" label.
 */
export function useShowAccountNumbers(): boolean {
  const { selectedOrganization } = useOrganization();
  return selectedOrganization?.show_account_numbers ?? true;
}
